import React, {useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setInterests} from '../actions'
import Interest from './Interest'
import GeneralModal from './GeneralModal'
import {interestSet} from '../ExData'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Interests() {
  const resumeInterests=useSelector(states=>states.resumeData).interests
  const dispatch=useDispatch()
  const history = useHistory();
  const exInterests=interestSet
  const [interests,setResumeInterests]=useState(()=>{
    return resumeInterests
  })
  const [interestValue,setInterestValue]=useState('')
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setInterests(interests))
    history.push("/introduction");
  }
  function chooseRandomInterest(){
    let index=Math.floor(Math.random()*exInterests[1].socialInterest.length)
    let choosenInterest=exInterests[1].socialInterest[index]
    setInterestValue(choosenInterest)
  }
  function addInterest(e){
    e.preventDefault();
    setResumeInterests((prevInterests)=>{
      if(prevInterests.includes(interestValue))
        return prevInterests
      return [...prevInterests,interestValue]
    })
  }
  function removeInterest(id){
    setResumeInterests((prevInterests)=>{
      return prevInterests.filter((interest,index)=>index!==id)
    })
  }
  useEffect(()=>{
    setInterestValue('')
  },[interests])
  const [showModal,setShowModal]=useState(false)
  return (
    <>
    <GeneralModal showModal={showModal} setShowModal={setShowModal}>
        <h4 className="mt-4 text-primary"><strong>Sample Interests</strong></h4>
        <p>you can refer the following interest set samples</p>
        <div className="sample-intro">
          <div className="sample-box">
            <h6><strong>Analytical interest</strong></h6>
            <ul>
              {exInterests[0].analyticalInterest.map((interest,index)=>(
                <li key={index}>{interest}</li>
              ))}
            </ul>
          </div>
          <div className="sample-box">
            <h6><strong>Social interest</strong></h6>
            <ul>
              {exInterests[1].socialInterest.map((interest,index)=>(
                <li key={index}>{interest}</li>
              ))}
            </ul>
          </div>
          <div className="sample-box">
            <h6><strong>Unique interest</strong></h6>
            <ul>
              {exInterests[2].uniqueInterest.map((interest,index)=>(
                <li key={index}>{interest}</li>
              ))}
            </ul>
          </div>
        </div>
        <small>simply search your relevant interests and add to your resume.</small>
    </GeneralModal>
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <div><h1><i className="fas fa-book-reader mr-2"></i>Interests</h1>
        <button className="text-light my-2 py-2 b-1 random-btn" onClick={chooseRandomInterest}>choose random</button>
        <button className="text-light my-2 py-2 b-1 random-btn" onClick={()=>setShowModal(true)}>refer sample</button>
        </div>
        <form onSubmit={addInterest}>
          <div className="input-btn">
            <input type="text" value={interestValue} onChange={(e)=>setInterestValue(e.target.value)} placeholder="add interest then press enter" required />
            <span className="pb-1 mb-2"><button type="submit"><i class="fas fa-plus"></i></button></span>
          </div><br/>
        </form>
        <ul>
          {interests.map((interest,index)=>{
            return (<Interest interest={interest} key={index} id={index} removeInterest={removeInterest} />)
          })}
        </ul>
        {interests!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
    </>
  );
}
